import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'excludedUrls'
})
export class ExcludedUrlsPipe implements PipeTransform {
  transform(url: string, excludedUrls?: string[]): boolean {
    // do not show the sidebar or installation selector on these pages
    excludedUrls = ['/surf/dataEntrySelection/dataEntry'];
    return !excludedUrls.some((route: string) => url.includes(route));
  }
}
